import IncidentSection7 from './IncidentSection7';

export default IncidentSection7;
